import merge from "lodash/merge"
import Cookies from "universal-cookie"

// fetchJSON is bundled wrapper around fetch which simplifies working
// with JSON API:
//   * Automatically adds Content-Type: application/json to request headers
//   * Parses response as JSON when Content-Type: application/json header is
//     present in response headers
//   * Converts non-ok responses to errors
import { configureRefreshFetch, fetchJSON } from "refresh-fetch"

var local = {
  apiUrl_pegaso_tools: null,
  access_token_pegaso_tools: null,
  companyId: null,
  refresh_token_pegaso_tools: null,
  setAccess_token_pegaso_tools: null,
  setRefresh_token_pegaso_tools: null,
  streaming: false,
}

const logout = () => {
  var companyId = local.companyId
  clearToken()
  window.location.href = `/#/${companyId}`
}

// Provide your favorite token saving -- to cookies, local storage, ...
function retrieveToken() {
  var result = local.access_token_pegaso_tools
  return result
}

const saveToken = (newToken) => {
  local.access_token_pegaso_tools = newToken
  sessionStorage.setItem("mini_access_token_pegaso_tools", newToken)
  if (local.setAccess_token_pegaso_tools !== null) local.setAccess_token_pegaso_tools(newToken)
}

const saveRefreshToken = (newToken) => {
  local.refresh_token_pegaso_tools = newToken
  const cookies = new Cookies()
  cookies.set("mini_refresh_token_pegaso_tools", newToken)
  if (local.setRefresh_token_pegaso_tools !== null) local.setRefresh_token_pegaso_tools(newToken)
}

const clearToken = () => {
  local.access_token_pegaso_tools = null
  //if(local.setAccess_token_pegaso_tools !== null) local.setAccess_token_pegaso_tools(null) // F5 -> Si blocca tutto se scommentato
}

// Add token to the request headers
const fetchJSONWithToken = (url, options = {}) => {
  if (local.companyId === null) local.companyId = options.companyId
  if (local.apiUrl_pegaso_tools === null) local.apiUrl_pegaso_tools = options.apiUrl_pegaso_tools
  if (local.access_token_pegaso_tools === null) local.access_token_pegaso_tools = options.access_token_pegaso_tools
  if (local.refresh_token_pegaso_tools === null) local.refresh_token_pegaso_tools = options.refresh_token_pegaso_tools
  if (local.setAccess_token_pegaso_tools === null) local.setAccess_token_pegaso_tools = options.setAccess_token_pegaso_tools
  if (local.streaming === null) local.streaming = options.streaming

  const accessToken = retrieveToken()
  let optionsWithToken = options
  if (accessToken != null) {
    if (accessToken.trim() !== "") {
      optionsWithToken = merge({}, options, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
    }
  }

  const isFormData = options.body instanceof FormData;
  if (isFormData) {
    return fetch(url, optionsWithToken);
  }

  if (local.streaming !== null) {
    if (options.streaming) {
      // Read in streaming
      return fetch(url, optionsWithToken)
    }
  }
  // Read normal json
  return fetchJSON(url, optionsWithToken)
}

// Add token to the request headers
const fetchJSONWithNoToken = (url, options = {}) => {
  return fetchJSON(url, options)
}

// Decide whether this error returned from API means that we want
// to try refreshing the token. error.response contains the fetch Response
// object, error.body contains the parsed JSON response body
const shouldRefreshToken = (error) => {
  return error.response
    ? (error.response.status === 401) ||
    (error.response.status === 500)
    : false
}

// Do the actual token refreshing and update the saved token
// IN AMBIENTE LOCALHOST NELLA VARIABILE LOCAL VENGONO PERSI I DATI QUANDO SI SALVA LA PAGINA
export const refreshToken = () => {
  const accessToken = retrieveToken()
  let refreshToken = local.refresh_token_pegaso_tools

  if (refreshToken != null) {
    if (refreshToken.trim() !== "") {
      return fetchJSONWithNoToken(
        `${local.apiUrl_pegaso_tools}/Account/refresh-token`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
          body: JSON.stringify({ refreshToken: refreshToken }),
        }
      )
        .then((response) => {
          // Save accessToken in cache
          var newAccessToken = response["body"]["accessToken"]
          saveToken(newAccessToken)

          // Save refreshToken in cache
          var newRefreshToken = response["body"]["refreshToken"]
          saveRefreshToken(newRefreshToken)

          return newAccessToken
        })
        .catch((error) => {
          //learToken()
          logout()
          throw error
        })
    } else {
      //clearToken()
      logout()
      throw new Error("token_expired")
    }
  } else {
    //clearToken()
    logout()
    throw new Error("token_expired")
  }
}

export const fetchWithTokenPegasoTools = configureRefreshFetch({
  shouldRefreshToken,
  refreshToken,
  fetch: fetchJSONWithToken,
})
